import React from 'react';
import Layout from '../../layout/Layout';
import SeoTags from '../../routes/SeoTags';

const CalculatorSftkPage = () => {
  return (
    <Layout
      className='calculator-sftk-page'
      breadcrumbs={[
        {label: 'Калькулятор СФТК'}
      ]}
    >
      <SeoTags
        seo_context={{
          title: 'Калькулятор СФТК',
          description: 'Калькулятор СФТК',
          keywords: 'Калькулятор СФТК',
        }}
      />

      <div className='container'>
        <iframe
          src='https://calc.bergauf.ru/facade/'
          width='100%'
          height='500'
          frameBorder='0'
          allowFullScreen
          title='Калькулятор СФТК'
        />
      </div>
    </Layout>
  );
};

export default CalculatorSftkPage;
